module.exports = __webpack_public_path__ + "static/media/test.e6756189.txt";